import { CALL_API } from '../middleware/ApiMiddleware';

export const WORK_SCHEDULE_FETCH_REQUEST = 'WORK_SCHEDULE_FETCH_REQUEST';
export const WORK_SCHEDULE_FETCH_SUCCESS = 'WORK_SCHEDULE_FETCH_SUCCESS';
export const WORK_SCHEDULE_FETCH_FAILURE = 'WORK_SCHEDULE_FETCH_FAILURE';

export const WORK_SCHEDULE_CREATE_REQUEST = 'WORK_SCHEDULE_CREATE_REQUEST';
export const WORK_SCHEDULE_CREATE_SUCCESS = 'WORK_SCHEDULE_CREATE_SUCCESS';
export const WORK_SCHEDULE_CREATE_FAILURE = 'WORK_SCHEDULE_CREATE_FAILURE';

export const WORK_SCHEDULE_UPDATE_REQUEST = 'WORK_SCHEDULE_UPDATE_REQUEST';
export const WORK_SCHEDULE_UPDATE_SUCCESS = 'WORK_SCHEDULE_UPDATE_SUCCESS';
export const WORK_SCHEDULE_UPDATE_FAILURE = 'WORK_SCHEDULE_UPDATE_FAILURE';

export const fetchWorkSchedule = () => ({
  [CALL_API]: {
    endpoint: 'agencies/config/work-schedule',
    method: 'get',
    authenticated: true,
    types: [WORK_SCHEDULE_FETCH_REQUEST, WORK_SCHEDULE_FETCH_SUCCESS, WORK_SCHEDULE_FETCH_FAILURE],
  },
});

export const createWorkSchedule = (workScheduleRequest: IAgencyScheduleRequest) => ({
  [CALL_API]: {
    endpoint: 'agencies/config/work-schedule',
    method: 'post',
    body: workScheduleRequest,
    authenticated: true,
    types: [WORK_SCHEDULE_CREATE_REQUEST, WORK_SCHEDULE_CREATE_SUCCESS, WORK_SCHEDULE_CREATE_FAILURE],
  },
});

export const editWorkSchedule = (workScheduleEditRequest: IAgencyScheduleEditRequest) => ({
  [CALL_API]: {
    endpoint: 'agencies/config/work-schedule',
    method: 'put',
    body: workScheduleEditRequest,
    authenticated: true,
    types: [WORK_SCHEDULE_UPDATE_REQUEST, WORK_SCHEDULE_UPDATE_SUCCESS, WORK_SCHEDULE_UPDATE_FAILURE],
  },
});
